<template>
    <div v-if="chartData.datasets.length > 0">
        <div class="card">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-primary">Atividades durante o ano</h6>
                <select class="form-control select-graph" v-model="year" @change="changeYearFilter">
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                </select>
            </div>
            <div class="card-body card-body-no-spaccing">
                <div class="row">
                    <div class="col-xl-12 col-md-12 col-sm-12">
                        <Line :data="chartData" :options="chartOptions" :style="style" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        Carregando dados...
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js'
import { Line } from 'vue-chartjs'
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { defineProps } from 'vue';

const year = ref(2026);


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const chartData = ref({
    labels: [],
    datasets: []
});

onMounted(async () => {
    loadData();
});
const chartOptions = ref({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            display: true, // Hides the x-axis labels and grid lines
        },
        y: {
            display: true, // Hides the y-axis labels and grid lines
        },
    }


});

const props = defineProps({
  userId:String
});


const style = ref({
    height: '230px', // Set your desired height here
    width: '100%',
    position: 'relative',
});

const changeYearFilter = () => {
    loadData();
};


const loadData = async () => {
    try {
        const response = await api.get('/activity/' + props.userId + '/graphLinearYear', { params: { 'year': year.value } }).then((response) => { return response; }).catch((error) => { handleRequestErrors(error.status) });
        const apiData = response.data;
        chartData.value = {
            labels: apiData.labels,
            datasets: [
                {
                    label: 'Concluídas',
                    borderColor: 'rgba(1,97,38, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(1,97,38, 0.3)',
                    data: apiData.completed
                },
                {
                    label: 'Pendentes',
                    borderColor: 'rgba(255, 155, 0, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(255, 155, 0, 0.3)',
                    data: apiData.pending
                },
                {
                    label: 'Em atraso',
                    borderColor: 'rgba(153, 19, 19, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(153, 19, 19, 0.3)',
                    data: apiData.overdue
                }
            ]
        };
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};
</script>